import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'kaz-button-feedback',
    templateUrl: './button-feedback.component.html',
    styleUrl: './button-feedback.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
})

export class ButtonFeedbackComponent {

}
